jQuery(function ($) {
  /** Modulaire : Galerie sauf .galerie-100 */
  $(".swiper-galerie:not(.galerie-100)").each(function (index) {
    $(this).addClass("swiper-galerie-" + index);

    new Swiper(".swiper-galerie-" + index, {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });

  /** Modulaire : .galerie-100 */
  $(".galerie-100").each(function (index) {
    $(this).addClass("galerie-100-" + index);

    new Swiper(".galerie-100-" + index, {
      centeredSlides: true,
      slidesPerView: 1,
      initialSlide: 2,
      loop: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
});
